import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import PropertyDtl from './PropertyDtl';

const PropertyDetails = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle='View Property' parent='Property' title='Property Details' />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <PropertyDtl />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default PropertyDetails